import { RIBBON_TOAST_AUTO_CLOSE_MS, showRibbonToast } from '@mi-front/ui';
import { Id } from 'react-toastify';
import {
  openNotificationActionUrl,
  opensNotificationActionInNewTab,
} from '../shared/notification-action-url';
import { NotificationSeverity } from '../shared/notification-severity';

export type ShowNotificationToastOptions = {
  title: string;
  eyebrow?: string | null;
  body?: string | null;
  severity: NotificationSeverity;
  actionLabel?: string | null;
  actionUrl?: string | null;
};

/** Auto-close duration for non-sticky notification toasts (matches in-card progress bar). */
export const NOTIFICATION_TOAST_AUTO_CLOSE_MS = RIBBON_TOAST_AUTO_CLOSE_MS;

/**
 * Shows a Knock notification as a shared ribbon toast (Paper + severity accent).
 */
export function showNotificationToast({
  title,
  eyebrow = null,
  body = null,
  severity,
  actionLabel = null,
  actionUrl = null,
}: ShowNotificationToastOptions): Id {
  const hasAction = Boolean(actionUrl && actionLabel);

  return showRibbonToast({
    title,
    eyebrow,
    body,
    severity,
    actionLabel: hasAction ? actionLabel : null,
    onAction: hasAction ? () => openNotificationActionUrl(actionUrl!) : undefined,
    opensInNewTab: hasAction ? opensNotificationActionInNewTab(actionUrl!) : false,
  });
}
